"use strict";

/**
 * Character classes and associated utilities for the 5th edition of XML 1.0.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
//
// Fragments.
//
exports.CHAR = "\t\n\r -\uD7FF\uE000-\uFFFD\uD800\uDC00-\uDBFF\uDFFF";
exports.S = " \t\r\n";
// tslint:disable-next-line:max-line-length
exports.NAME_START_CHAR = ":A-Z_a-z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\uD800\uDC00-\uDB7F\uDFFF";
exports.NAME_CHAR = "-" + exports.NAME_START_CHAR + ".0-9\xB7\u0300-\u036F\u203F-\u2040";
//
// Regular expressions.
//
exports.CHAR_RE = new RegExp("^[" + exports.CHAR + "]$", "u");
exports.S_RE = new RegExp("^[" + exports.S + "]+$", "u");
exports.NAME_START_CHAR_RE = new RegExp("^[" + exports.NAME_START_CHAR + "]$", "u");
exports.NAME_CHAR_RE = new RegExp("^[" + exports.NAME_CHAR + "]$", "u");
exports.NAME_RE = new RegExp("^[" + exports.NAME_START_CHAR + "][" + exports.NAME_CHAR + "]*$", "u");
exports.NMTOKEN_RE = new RegExp("^[" + exports.NAME_CHAR + "]+$", "u");
var TAB = 9;
var NL = 0xA;
var CR = 0xD;
var SPACE = 0x20;
//
// Lists.
//
/** All characters in the ``S`` production. */
exports.S_LIST = [SPACE, NL, CR, TAB];
/**
 * Determines whether a codepoint matches the ``CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``CHAR``.
 */
function isChar(c) {
  return c >= SPACE && c <= 0xD7FF || c === NL || c === CR || c === TAB || c >= 0xE000 && c <= 0xFFFD || c >= 0x10000 && c <= 0x10FFFF;
}
exports.isChar = isChar;
/**
 * Determines whether a codepoint matches the ``S`` (space) production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``S``.
 */
function isS(c) {
  return c === SPACE || c === NL || c === CR || c === TAB;
}
exports.isS = isS;
/**
 * Determines whether a codepoint matches the ``NAME_START_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_START_CHAR``.
 */
function isNameStartChar(c) {
  return c >= 0x41 && c <= 0x5A || c >= 0x61 && c <= 0x7A || c === 0x3A || c === 0x5F || c === 0x200C || c === 0x200D || c >= 0xC0 && c <= 0xD6 || c >= 0xD8 && c <= 0xF6 || c >= 0x00F8 && c <= 0x02FF || c >= 0x0370 && c <= 0x037D || c >= 0x037F && c <= 0x1FFF || c >= 0x2070 && c <= 0x218F || c >= 0x2C00 && c <= 0x2FEF || c >= 0x3001 && c <= 0xD7FF || c >= 0xF900 && c <= 0xFDCF || c >= 0xFDF0 && c <= 0xFFFD || c >= 0x10000 && c <= 0xEFFFF;
}
exports.isNameStartChar = isNameStartChar;
/**
 * Determines whether a codepoint matches the ``NAME_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_CHAR``.
 */
function isNameChar(c) {
  return isNameStartChar(c) || c >= 0x30 && c <= 0x39 || c === 0x2D || c === 0x2E || c === 0xB7 || c >= 0x0300 && c <= 0x036F || c >= 0x203F && c <= 0x2040;
}
exports.isNameChar = isNameChar;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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